"use strict";

/**
 * Character classes and associated utilities for the 5th edition of XML 1.0.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
//
// Fragments.
//
exports.CHAR = "\t\n\r -\uD7FF\uE000-\uFFFD\uD800\uDC00-\uDBFF\uDFFF";
exports.S = " \t\r\n";
// tslint:disable-next-line:max-line-length
exports.NAME_START_CHAR = ":A-Z_a-z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\uD800\uDC00-\uDB7F\uDFFF";
exports.NAME_CHAR = "-" + exports.NAME_START_CHAR + ".0-9\xB7\u0300-\u036F\u203F-\u2040";
//
// Regular expressions.
//
exports.CHAR_RE = new RegExp("^[" + exports.CHAR + "]$", "u");
exports.S_RE = new RegExp("^[" + exports.S + "]+$", "u");
exports.NAME_START_CHAR_RE = new RegExp("^[" + exports.NAME_START_CHAR + "]$", "u");
exports.NAME_CHAR_RE = new RegExp("^[" + exports.NAME_CHAR + "]$", "u");
exports.NAME_RE = new RegExp("^[" + exports.NAME_START_CHAR + "][" + exports.NAME_CHAR + "]*$", "u");
exports.NMTOKEN_RE = new RegExp("^[" + exports.NAME_CHAR + "]+$", "u");
var TAB = 9;
var NL = 0xA;
var CR = 0xD;
var SPACE = 0x20;
//
// Lists.
//
/** All characters in the ``S`` production. */
exports.S_LIST = [SPACE, NL, CR, TAB];
/**
 * Determines whether a codepoint matches the ``CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``CHAR``.
 */
function isChar(c) {
  return c >= SPACE && c <= 0xD7FF || c === NL || c === CR || c === TAB || c >= 0xE000 && c <= 0xFFFD || c >= 0x10000 && c <= 0x10FFFF;
}
exports.isChar = isChar;
/**
 * Determines whether a codepoint matches the ``S`` (space) production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``S``.
 */
function isS(c) {
  return c === SPACE || c === NL || c === CR || c === TAB;
}
exports.isS = isS;
/**
 * Determines whether a codepoint matches the ``NAME_START_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_START_CHAR``.
 */
function isNameStartChar(c) {
  return c >= 0x41 && c <= 0x5A || c >= 0x61 && c <= 0x7A || c === 0x3A || c === 0x5F || c === 0x200C || c === 0x200D || c >= 0xC0 && c <= 0xD6 || c >= 0xD8 && c <= 0xF6 || c >= 0x00F8 && c <= 0x02FF || c >= 0x0370 && c <= 0x037D || c >= 0x037F && c <= 0x1FFF || c >= 0x2070 && c <= 0x218F || c >= 0x2C00 && c <= 0x2FEF || c >= 0x3001 && c <= 0xD7FF || c >= 0xF900 && c <= 0xFDCF || c >= 0xFDF0 && c <= 0xFFFD || c >= 0x10000 && c <= 0xEFFFF;
}
exports.isNameStartChar = isNameStartChar;
/**
 * Determines whether a codepoint matches the ``NAME_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_CHAR``.
 */
function isNameChar(c) {
  return isNameStartChar(c) || c >= 0x30 && c <= 0x39 || c === 0x2D || c === 0x2E || c === 0xB7 || c >= 0x0300 && c <= 0x036F || c >= 0x203F && c <= 0x2040;
}
exports.isNameChar = isNameChar;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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